import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { FormMode, Languages, ServiceStatus, NavigationConfirmPenaltyDecision, TransitRequestWFSteps, TransitCancelWorkflowSteps } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TransitRequestCustomDTO } from 'src/app/shared/models/transit-request-custom-dto.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { Router } from '@angular/router';
import { MarineEstimatePenaltyComponent } from '../marine-estimate-penalty/marine-estimate-penalty.component';

@Component({
  selector: 'app-navigation-confirm-penalty',
  templateUrl: './navigation-confirm-penalty.component.html',
  styleUrls: ['./navigation-confirm-penalty.component.css']
})
export class NavigationConfirmPenaltyComponent implements OnInit {
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  stepId: number = TransitCancelWorkflowSteps.ConfirmPenalty;
  navigationConfirmPenaltyForm: FormGroup;
  submitted = false;
  showRequest = false;
  isErrorMessage = false;
  lockTaskErrorMessage = false;
  decision = NavigationConfirmPenaltyDecision;
  decisionKeys = Object.keys(this.decision);
  decisionValue: number;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest;
  displayedLang: string;
  currentUser: User = new User();
  transitRequestCustomObj: TransitRequestCustomDTO = new TransitRequestCustomDTO();
  isLoaded: boolean = false;
  @ViewChild('marineEstimatePenalty', { static: false }) marineEstimatePenalty: MarineEstimatePenaltyComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  stepHistoryId: any;
  stepData: any;
  @Input() isReadOnly: boolean = false;
  appInstanceId: string = '';
  public transitRequestIdd: string = '';
  public penaltyIdToSearch: string = '';



  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private transitService: TransitService,
    private wfhistoryService: WFHistoryService,
    private router: Router,
  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.stepHistoryId = history.state.data.stepHistoryId;
      this.baseRequestId = history.state.data.requestId;
      // this.baseRequestId = "A1EABCF5-33FE-427C-A871-93ECEEF05F0F";
      this.appInstanceId = history.state.data.appInstanceId;
      if (this.appInstanceId && this.appInstanceId.includes('_')) {
        this.transitRequestIdd = this.appInstanceId.split('_')[0];
        this.penaltyIdToSearch = this.appInstanceId.split('_')[1];
      } else {
        this.transitRequestIdd = this.appInstanceId; // Fallback
      }

      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm(null);
    if (this.isReadOnly) {
      this.navigationConfirmPenaltyForm.disable();
      this.formMode = FormMode.Readonly;
    } else {
      this.navigationConfirmPenaltyForm.enable();
    }
  }


  buildForm(decision) {
    this.navigationConfirmPenaltyForm = this.formBuilder.group({
      Decision: ['', Validators.required],
    });
    if (decision == NavigationConfirmPenaltyDecision.CANCEL_PENALTY) {
      this.navigationConfirmPenaltyForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        CancelPenaltyReason: [''],
      });
    } else if (decision == NavigationConfirmPenaltyDecision.CONFIRM_PENALTY) {
      this.navigationConfirmPenaltyForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        ApplyPenaltyReason: [''],
      });
    }
  }

  changeDecision(value) {
    this.buildForm(value);
    this.navigationConfirmPenaltyForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() { return this.navigationConfirmPenaltyForm.controls; }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.isLoaded = true;
        if (history.state.data && history.state.data.isCompleted && history.state.data.StepId == this.stepId) { // Request History
          this.formMode = FormMode.Readonly;
          this.getTransitCancelRequestWFHistoryById();
        } else if (this.isReadOnly) {
          this.getTransitCancelRequestWFHistory();
        }
      }
    )
  }

  getTransitCancelRequestWFHistory() {
    this.wfhistoryService.getByRequestIdByStepIdByPenaltyID(this.baseRequestId, this.stepId, this.penaltyIdToSearch).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
          this.getTransitCancelRequestWFHistoryCompleted(this.stepData);
        }
      }

    );
  }

  getTransitCancelRequestWFHistoryById() {
    this.wfhistoryService.getByRequestIdByStepIdByIdByPenaltyID(this.baseRequestId, this.stepId, this.stepHistoryId, this.penaltyIdToSearch).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        this.stepData = this.responseObj.Data["StepData"] ? JSON.parse(this.responseObj.Data["StepData"]) : null;
        this.getTransitCancelRequestWFHistoryCompleted(this.stepData);
      }

    );
  }

  getTransitCancelRequestWFHistoryCompleted(stepData: any) {
    if (!stepData) return;
    this.decisionValue = this.stepData.Decision;
    this.changeDecision(this.decisionValue);
    if (this.decisionValue == NavigationConfirmPenaltyDecision.CANCEL_PENALTY) {
      this.navigationConfirmPenaltyForm.patchValue({
        CancelPenaltyReason: this.stepData.CancelPenaltyReason
      });
    } else if (this.decisionValue == NavigationConfirmPenaltyDecision.CONFIRM_PENALTY) {
      this.navigationConfirmPenaltyForm.patchValue({
        ApplyPenaltyReason: this.stepData.ApplyPenaltyReason
      });
    }
    this.navigationConfirmPenaltyForm.disable();
  }


  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.navigationConfirmPenaltyForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.transitRequestCustomObj.RequestId = this.baseRequestId;
    //this.transitRequestCustomObj.IsVesselTransited = this.navigationConfirmPenaltyForm.controls['Decision'].value == NavigationConfirmPenaltyDecision.CONFIRM_PENALTY ? true : false;
    this.transitRequestCustomObj.StepId = this.stepId;
    this.transitRequestCustomObj.StepData = JSON.stringify(this.navigationConfirmPenaltyForm.getRawValue());
    this.transitRequestCustomObj.CompletedBy = this.currentUser.UserName;
    this.transitRequestCustomObj.ComponentURL = this.router ? this.router.url.split('/')[1] + '/' + this.router.url.split('/')[2] : '';
    this.transitRequestCustomObj.IsAdmin = this.currentUser.IsAdmin;
    this.transitRequestCustomObj.DirectionId = this.marineEstimatePenalty.TransitRequest.feesRequest.feesDetailsForm.get('DirectionId')?.value;
    this.transitRequestCustomObj.AppInstanceId = this.appInstanceId;



    this.transitService.SubmitConfirmPenaltyDecision(this.transitRequestCustomObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.navigationConfirmPenaltyForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
